import { usePortfolio } from '../context/PortfolioContext';

const DynamicSections = () => {
  const { portfolioData, loading } = usePortfolio();
  const sections = portfolioData?.sections || [];

  if (loading) {
    return <div className="text-center text-gray-400 py-8">Loading sections...</div>;
  }

  if (!sections.length) {
    return null;
  }

  const visibleSections = sections.filter(section => section.visible);

  return (
    <div className="dynamic-sections">
      {visibleSections.map(section => (
        <section key={section.id} className="py-12">
          <h2 className="text-2xl font-bold text-primary mb-4">{section.section_title}</h2>
          <div className="text-gray-200 mb-4">{section.content}</div>
          {section.image_url && (
            <img
              src={section.image_url}
              alt={section.section_title}
              className="rounded-lg max-w-full h-auto"
              onError={e => { e.target.onerror = null; e.target.src = '/default-image.png'; }}
            />
          )}
        </section>
      ))}
    </div>
  );
};

export default DynamicSections; 